import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=1faab9b8&scoped=true&"
import script from "./EmptyView.vue?vue&type=script&lang=js&"
export * from "./EmptyView.vue?vue&type=script&lang=js&"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=1faab9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faab9b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
